module.exports = __webpack_public_path__ + "static/media/mobile_bar_android.77cd3eb7.svg";